<template lang="pug">
  form.standard.contact.component( @submit.prevent='submit' )
    h2 LET'S WORK TOGETHER
    .fields
      animated-input.on-dark.name
        input( v-model='contact.name' type='text' placeholder='Your Name')

      divider.card.borderless
      animated-input.on-dark.email
        template( v-slot:icon )
          email-icon
        input( v-model='contact.email' type='email' placeholder='Email Address')

      divider.card.borderless
      animated-input.on-dark.msg
        template( v-slot:icon )
          text-icon
        textarea( v-model='contact.msg' placeholder='Type a message' )

      divider.section.borderless.on-medium
      .buttons
        basic-button.on-dark( type='submit' ) Send
</template>

<script>
  import { db } from '@/main'

  import AnimatedInput from '@/components/inputs/animated'
  import BasicButton from '@/components/buttons/basic'
  import Divider from '@/components/containers/divider'
  import EmailIcon from 'vue-material-design-icons/Email'
  import TextIcon from 'vue-material-design-icons/FormTextbox'

  export default {
    name: 'standard.contact.form.component',

    components: {
      AnimatedInput,
      BasicButton,
      EmailIcon,
      TextIcon,
      Divider
    },

    props: {
      // contact: { type: Object, required: true, default: () => ({}) }
    },

    data() {
      return {
        contact: {}
      }
    },

    methods: {
      submit() {
        db.collection( 'contacts' ).add( this.contact ).then( doc => 
          this.$router.push({ name: 'blog' })
        )
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .contact
    background rgb( 80 80 80 )
    padding 96px 144px
    border-radius 3px
    box-shadow 0 36px 56px rgb( 96 96 96 .1 )

  .fields
    margin-top 32px

  .buttons
    text-align center

  h2
    color rgb( 200 150 100 )
    text-shadow 0px -1px 1px rgba( 0 0 0 .25 )
    // text-align center

  input, textarea
    // min-width 16em
    // max-width 100%
  textarea
    width 100%
    height 8em
</style>